module.exports = __webpack_public_path__ + "jab/media/pgs.0b520ce0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/pgs.svg
// module id = 1480
// module chunks = 0